// extracted by mini-css-extract-plugin
export default {"Skill":"Skill_Skill__AXosr","Title":"Skill_Title__QDmkv","Value":"Skill_Value__Ws1a3"};